import { render, staticRenderFns } from "./Takeaway.vue?vue&type=template&id=9485fff4&scoped=true"
import script from "./Takeaway.vue?vue&type=script&lang=ts"
export * from "./Takeaway.vue?vue&type=script&lang=ts"
import style0 from "./Takeaway.vue?vue&type=style&index=0&id=9485fff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9485fff4",
  null
  
)

export default component.exports